import { createUseStyles } from "react-jss";
import TypographyDefault from "./TypographyDefault.style";
import { ITheme } from "../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => {
  const textStyle: { [key: string]: unknown } = TypographyDefault;
  return {
    root: {
      fontFamily: "Poppins",
      fontWeight: "400",
      fontStyle: "normal",
      letterSpacing: "0px",
      margin: 0,
      padding: 0,
      // ===========================================================
      // Colors
      // ===========================================================

      // Primary & Secondary
      "&.primary": { color: theme.colors.text0 },
      "&.secondary": { color: theme.colors.text1 },
      "&.text-1": { color: theme.colors.text1 },
      "&.text-2": { color: theme.colors.text2 },
      "&.text-3": { color: theme.colors.text3 },
      "&.text-error": { color: theme.colors.error },

      // ===========================================================
      // Font style, decoration, size, line height
      // ===========================================================

      ...textStyle,
    },
  };
});
